import type { SVGProps } from 'react';

/**
 * YouTube "symbol" glyph — replicated verbatim from Figma's icon component
 * (node 5422:4241, file 0Vugg58oB0iBf1CxP0CUyp). Used by both the
 * Integrated and Dedicated deliverable cards (same Figma component instance
 * for both — Figma doesn't distinguish them by icon). A monochrome
 * rounded-rect outline + play triangle — NOT the colorful red/white YouTube
 * badge — so unlike that badge this one does use `currentColor`, composing
 * with the same treatment as the other deliverable glyphs.
 */
export function YoutubePlayIcon({
  size = 18,
  className,
  weight: _weight,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number; weight?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size * (16.7999 / 24)}
      viewBox="0 0 24 16.7999"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M12.084 0.5C12.1389 0.500122 12.2197 0.500492 12.3232 0.500977C12.5312 0.501952 12.8311 0.503909 13.1963 0.507812C13.9271 0.515625 14.9207 0.531285 15.9717 0.5625C17.0235 0.593739 18.1294 0.640198 19.0859 0.709961C20.0563 0.780737 20.8311 0.872982 21.2471 0.984375H21.248C22.1076 1.21426 22.7858 1.89252 23.0156 2.75195V2.75293C23.2511 3.63203 23.3747 5.02754 23.4375 6.23926C23.4685 6.83773 23.4844 7.379 23.4922 7.77051C23.4961 7.96584 23.4981 8.12365 23.499 8.23242C23.4995 8.28668 23.4999 8.3291 23.5 8.35742V8.44238C23.4999 8.47062 23.4995 8.51243 23.499 8.56641C23.4981 8.67521 23.4961 8.83367 23.4922 9.0293C23.4844 9.42082 23.4685 9.96207 23.4375 10.5605C23.3747 11.7723 23.2511 13.1679 23.0156 14.0469V14.0479C22.7857 14.9073 22.1074 15.5858 21.248 15.8154H21.2471C20.8311 15.9269 20.0563 16.019 19.0859 16.0898C18.1294 16.1596 17.0235 16.2061 15.9717 16.2373C14.9207 16.2685 13.9271 16.2842 13.1963 16.292C12.8311 16.2959 12.5312 16.2979 12.3232 16.2988C12.2197 16.2993 12.1389 16.2997 12.084 16.2998H11.916C11.861 16.2997 11.7796 16.2993 11.6758 16.2988C11.4679 16.2979 11.1686 16.2959 10.8037 16.292C10.0729 16.2842 9.0793 16.2685 8.02832 16.2373C6.97654 16.2061 5.87064 16.1596 4.91406 16.0898C3.9437 16.019 3.16886 15.9269 2.75293 15.8154H2.75195C1.89255 15.5858 1.21425 14.9073 0.984375 14.0479V14.0469C0.748864 13.1679 0.625283 11.7723 0.5625 10.5605C0.531494 9.96207 0.515574 9.42082 0.507812 9.0293C0.503935 8.83367 0.501942 8.67521 0.500977 8.56641C0.500499 8.51243 0.500119 8.47062 0.5 8.44238V8.35742C0.50012 8.3291 0.500495 8.28668 0.500977 8.23242C0.501943 8.12365 0.503941 7.96584 0.507812 7.77051C0.515574 7.379 0.531494 6.83773 0.5625 6.23926C0.62528 5.02754 0.748877 3.63203 0.984375 2.75293V2.75195C1.2142 1.89252 1.89244 1.21426 2.75195 0.984375H2.75293C3.16888 0.872981 3.94371 0.780737 4.91406 0.709961C5.87065 0.640196 6.97654 0.593739 8.02832 0.5625C9.0793 0.531285 10.0729 0.515625 10.8037 0.507812C11.1686 0.503912 11.4679 0.501952 11.6758 0.500977C11.7796 0.50049 11.861 0.500122 11.916 0.5H12.084Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6 11.9999L15.835 8.40005L9.6 4.7998V11.9999Z"
        fill="currentColor"
      />
    </svg>
  );
}
